export const accountMenuId = 'id_account_menu';
export const downloadsMenuId = 'id_reports_downloads';
export const languagePlaceholder = '{{LANGUAGE_CODE}}';
export const websiteUrl = '/overview/';

export const languageMap: Record<Language, string> = Object.freeze({
    en: 'English',
    nl: 'Nederlands',
    de: 'Deutsch',
    fr: 'Français',
});
